export default __webpack_public_path__ + "static/media/ic_svg_notificacion.cdf94940.svg";